import '@/features/Buttons/Close/styles/index.scss';
import CloseIcon from '@/features/Icons/CloseIcon';
import { usePopup } from '@/features/Popup/usePopup';
import { useStore } from '@/store/useStore';
import {
  TRACK_USER_ACTION_EVENT,
  getExitModalZone,
  useTrackUserAction,
} from '@/utilities/logger/amplitude/tracking';
import { POPUP_TYPES } from '@/features/Popup/constants';

const EXIT_MODAL_POPUP_TYPES: ReadonlyArray<string> = [
  POPUP_TYPES.EXIT,
  POPUP_TYPES.EXIT_RECENTLY,
];

export const CloseButton = ({ parentComponent }: CloseButtonPropTypes) => {
  const { hidePopup } = usePopup();
  const { trackUserAction } = useTrackUserAction();

  const handleClose = () => {
    const currentPopupType = useStore.getState().state?.[0]?.type;
    if (
      currentPopupType &&
      EXIT_MODAL_POPUP_TYPES.includes(currentPopupType as string)
    ) {
      trackUserAction({
        event: TRACK_USER_ACTION_EVENT.IN_GAME_EXIT_MODAL_CLOSED,
        zone: getExitModalZone(),
        linkText: 'Close',
      });
    }
    hidePopup();
  };

  return (
    <button className={`${parentComponent}__close`} onClick={handleClose}>
      <CloseIcon color={'gray'} size={'25'} strokeWidth={'2.59'} />
    </button>
  );
};

type CloseButtonPropTypes = {
  parentComponent: 'popup' | string;
};
